import { motion } from 'framer-motion'
import { FolderKanban, Target, UserCheck, Users } from 'lucide-react'
import type { ClienteAgradaRow } from '@/services/clientesService'
import { cn } from '@/utils/cn'

type StatItem = {
  label: string
  value: number
  icon: typeof Users
  accent: string
  iconBg: string
  delay?: number
}

function StatCard({ label, value, icon: Icon, accent, iconBg, delay = 0 }: StatItem) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      className='glass-card relative overflow-hidden p-4'
    >
      <div
        className='absolute left-0 top-0 h-[2px] w-full'
        style={{ backgroundImage: `linear-gradient(to right, transparent, ${accent}66, transparent)` }}
      />
      <div className='mb-2 flex items-center justify-between'>
        <div
          className='flex h-10 w-10 items-center justify-center rounded-xl'
          style={{ backgroundColor: iconBg, color: accent }}
        >
          <Icon size={20} />
        </div>
      </div>
      <p
        className='mb-1 font-medium uppercase tracking-wider text-[var(--font-color-label)]'
        style={{ fontSize: 'var(--font-size-label)' }}
      >
        {label}
      </p>
      <p className='text-2xl font-black text-[var(--font-color-body)]'>{value}</p>
    </motion.div>
  )
}

export function ClientesAgradaStatsCards({
  totalItems,
  clientes,
}: {
  totalItems: number
  clientes: ClienteAgradaRow[]
}) {
  const comProjeto = clientes.filter((c) => c._count.financeProjects > 0).length
  const comDeal = clientes.filter((c) => c.clienteAtivos.length > 0).length
  const projetosTotal = clientes.reduce((sum, c) => sum + c._count.financeProjects, 0)

  const cards: StatItem[] = [
    {
      label: 'Clientes ativos',
      value: totalItems,
      icon: Users,
      accent: '#ef4444',
      iconBg: 'rgba(239, 68, 68, 0.12)',
    },
    {
      label: 'Com deal ganho',
      value: comDeal,
      icon: Target,
      accent: '#10b981',
      iconBg: 'rgba(16, 185, 129, 0.12)',
      delay: 0.05,
    },
    {
      label: 'Com projeto financeiro',
      value: comProjeto,
      icon: UserCheck,
      accent: '#6366f1',
      iconBg: 'rgba(99, 102, 241, 0.12)',
      delay: 0.1,
    },
    {
      label: 'Projetos na lista',
      value: projetosTotal,
      icon: FolderKanban,
      accent: '#f59e0b',
      iconBg: 'rgba(245, 158, 11, 0.12)',
      delay: 0.15,
    },
  ]

  return (
    <div className={cn('mb-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4')}>
      {cards.map((card) => (
        <StatCard key={card.label} {...card} />
      ))}
    </div>
  )
}
